const StayPaymentModel = {
    pay_stay_date: '',
    pay_stay_ref: '',
    pay_stay_amount: 0.0,
    stay_id: 0,
    payement_type_id: 0,
};
export default StayPaymentModel;